import { render, staticRenderFns } from "./PowerTranslateHead.vue?vue&type=template&id=cb0cac8c&scoped=true"
import script from "./PowerTranslateHead.vue?vue&type=script&lang=js"
export * from "./PowerTranslateHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0cac8c",
  null
  
)

export default component.exports